<ng-container [formGroup]="newEditForm">
  <td>{{almacen ? almacen.id : '' }}</td>
  <td class="string-long" [ngClass]="{'show-error': showError}">
    <textarea formControlName="des" title="Almacen"></textarea>
  </td>
  <td class="string-long" [ngClass]="{'show-error': showError}">
    <textarea formControlName="direccion" title="Direccion"></textarea>
  </td>
  <td class="short" [ngClass]="{'show-error': showError}">
    <app-filterable-list [itemsList]="paises" [selectedItem]="newEditForm.get('paisId')" [disabled]="disabledPaises" [placeHolder]="false">
    </app-filterable-list>
  </td>
  <td class="short" [ngClass]="{'show-error': showError}">
    <app-filterable-list [itemsList]="provincias" [selectedItem]="newEditForm.get('provinciaId')"
      [disabled]="disabledProvincias" [placeHolder]="false"></app-filterable-list>
  </td>
  <td class="short" [ngClass]="{'show-error': showError}">
    <app-filterable-list [itemsList]="municipios" [selectedItem]="newEditForm.get('municipioId')"
      [disabled]="disabledMunicipios" [placeHolder]="false"></app-filterable-list>
  </td>
  <td class="short" [ngClass]="{'show-error': showError}">
    <app-filterable-list [itemsList]="timezones" [selectedItem]="newEditForm.get('msTimeZoneId')"
      [disabled]="disabledTimezones" [placeHolder]="false"></app-filterable-list>
  </td>
  <td class="short">
    <input type="text" formControlName="longitud" title="{{'titles.longitud' | translate}}">
    <input type="text" formControlName="latitud" title="{{'titles.latitud' | translate}}">
  </td>
  <td class="multi-actions">
    <ng-container *ngIf="editable">
      <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
      <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
    </ng-container>
    <ng-container *ngIf="!editable">
      <i class="fa-xl icon-location-pin-edit" title="{{'titles.editarGeometria' | translate}}"
        *ngIf="almacen.geometria && (this.role === 'Administrador' || this.claims.includes('D_ETD_AlmacenGeoIns'))"
        app-click-stop-propagation (click)="openAppEdicion(almacen)"></i>
      <i class="fa-xl icon-location-pin-plus" title="{{'titles.addGeometria' | translate}}"
        *ngIf="!almacen.geometria && (this.role === 'Administrador' || this.claims.includes('D_ETD_AlmacenGeoUpd'))"
        app-click-stop-propagation (click)="openAppEdicion(almacen)"></i>
      <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}"
        *ngIf="this.role === 'Administrador'" (click)="edit(almacen)"></i>
      <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" app-click-stop-propagation
        *ngIf="this.role === 'Administrador'" (click)="askDelete(almacen)"
        [ngClass]="{'disabled': (this.almacen && this.almacen.almacenEnUso)}"></i>
    </ng-container>
  </td>
</ng-container>
<div class="modal" *ngIf="deleteModal">
  <div class="modal-content">
    <header>
      <h4>{{'global.eliminar.descripcion' | translate}}</h4>
    </header>
    <content>
      <p>{{'global.eliminar.confirmacion' | translate}}</p>
    </content>
    <footer>
      <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
      <button (click)="delete()">{{'global.confirmar' | translate}}</button>
    </footer>
  </div>
</div>
<div class="modal-map" *ngIf="edicionModal">
  <div class="modal-content">
    <div>
      <i class="fas fa-times" (click)="closeMap()"></i>
    </div>
    <app-map [app]="'ALM'" [open]="open" [etiquetadorId]="etiquetadorEdicion" [almacenId]="almacenId"></app-map>
  </div>
</div>
